import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Mic2, Users, Brain, Trophy, Smile } from "lucide-react";

const StandUpTeamBuilding = () => (
  <SeoPageLayout title="Stand-up" titleAccent="na team building">
    <SeoSection title="Team building z humorem">
      <p>Tradycyjne team buildingi - paintball, escape room, warsztaty kulinarne - są świetne, ale co powiesz na coś naprawdę wyjątkowego? Stand-up na team buildingu to innowacyjne podejście do integracji zespołu. Wspólny śmiech buduje więzi szybciej niż jakiekolwiek ćwiczenie grupowe.</p>
    </SeoSection>

    <SeoSection title="Formaty team buildingowe z elementem komedii">
      <SeoFeatureGrid features={[
        { icon: Mic2, title: "Stand-up wieczorny", description: "Główna atrakcja wieczoru integracyjnego z pełnym show." },
        { icon: Brain, title: "Warsztaty stand-up", description: "Pracownicy sami tworzą i prezentują żarty pod okiem komika." },
        { icon: Users, title: "Improwizacja", description: "Interaktywny show improwizacyjny z udziałem całego zespołu." },
        { icon: Trophy, title: "Komediowy quiz", description: "Firmowy quiz prowadzony przez profesjonalnego komika." },
      ]} />
    </SeoSection>

    <SeoSection title="Warsztaty stand-up comedy dla zespołów">
      <p>Oferujemy unikalne warsztaty, podczas których pracownicy uczą się podstaw komedii stand-upowej. Pod okiem doświadczonego komika uczestnicy tworzą własne żarty i prezentują je przed kolegami. To niesamowite doświadczenie, które buduje pewność siebie, umiejętność wystąpień publicznych i przede wszystkim - świetną zabawę.</p>
    </SeoSection>

    <SeoSection title="Dlaczego humor działa lepiej niż paintball?">
      <p>W paintballu jedni wygrywają, drudzy przegrywają. W stand-upie wygrywają wszyscy. Wspólny śmiech nie dzieli - łączy. Nie wymaga sprawności fizycznej, nie tworzy podziałów na zwycięzców i przegranych. To demokratyczna forma rozrywki, która angażuje każdego uczestnika bez wyjątku.</p>
      <SeoHighlightBox icon={Smile}>
        Wspólny śmiech to najskuteczniejszy team building - nie wymaga formułek, nie dzieli na wygranych i przegranych.
      </SeoHighlightBox>
    </SeoSection>

    <SeoSection title="Organizacja team buildingu z komikiem">
      <p>Pomagamy zaplanować cały wieczór team buildingowy. Doradzamy w kwestii harmonogramu, lokalizacji i formatu. Niezależnie od tego, czy planujesz kameralny wyjazd dla 15 osób, czy duży event dla 200+ pracowników - mamy doświadczenie i zasoby, by dostarczyć niezapomniane przeżycie.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default StandUpTeamBuilding;
